import { InjectionToken } from '@angular/core';

export const LOGO_CONFIG = new InjectionToken<{ logoUrl: string }>(
  'LOGO_CONFIG',
  {
    providedIn: 'root',
    factory: () => ({
      logoUrl: '/assets/offer-mob-app/logo.svg',
    }),
  },
);
